import { useState } from 'react';

import { AuditLogTable } from '../../components/settings/AuditLogTable';
import { LoginEventsSection } from '../../components/settings/LoginEventsSection';
import { SheetsSection } from '../../components/settings/SheetsSection';
import { SlaSection } from '../../components/settings/SlaSection';
import { TeamSection } from '../../components/settings/TeamSection';
import { TelegramSection } from '../../components/settings/TelegramSection';
import { ContactSourcesSection } from '../../components/contacts/ContactSourcesSection';
import { cn } from '../../lib/cn';
import { useSession } from '../../hooks/use-session';

const TABS = [
  { id: 'team', label: 'Команда' },
  { id: 'logins', label: 'Входы', ownerOnly: true },
  { id: 'telegram', label: 'Telegram' },
  { id: 'sheets', label: 'Sheets' },
  { id: 'sla', label: 'SLA и рабочие часы' },
  { id: 'contacts', label: 'Источники контактов' },
  { id: 'audit', label: 'Аудит-лог' },
] as const satisfies ReadonlyArray<{ id: string; label: string; ownerOnly?: boolean }>;

type TabId = (typeof TABS)[number]['id'];

export function SettingsPage() {
  const { me } = useSession();
  const canManageTeam = me?.role === 'owner';
  const canManageContactSources = me?.role === 'owner' || me?.role === 'lead';
  const [tab, setTab] = useState<TabId>('team');

  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border px-4 py-3">
        <h1 className="text-lg font-semibold">Настройки</h1>
      </div>
      <div className="flex gap-1 border-b border-border px-4">
        {TABS.filter((t) => !('ownerOnly' in t) || canManageTeam).map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={cn(
              'border-b-2 px-3 py-2 text-sm font-medium',
              tab === t.id ? 'border-primary text-primary' : 'border-transparent text-muted-fg hover:text-fg',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {tab === 'team' && <TeamSection canManage={canManageTeam} />}
        {tab === 'logins' && canManageTeam && <LoginEventsSection />}
        {tab === 'telegram' && <TelegramSection />}
        {tab === 'sheets' && <SheetsSection />}
        {tab === 'sla' && <SlaSection />}
        {tab === 'contacts' && <ContactSourcesSection canManage={canManageContactSources} />}
        {tab === 'audit' && <AuditLogTable />}
      </div>
    </div>
  );
}
